// Fixed-timestep driver. Accumulates real elapsed time and advances the sim in
// constant FIXED_DT steps (so the core stays deterministic), clamping the number
// of sub-steps per frame to avoid a spiral of death after a stall.

import { FIXED_DT } from '../core';

const MAX_SUBSTEPS = 5;
const MAX_FRAME_DT = 0.25; // seconds; cap a long stall (e.g. backgrounded tab)

export function startGameLoop(tick: () => void, draw: () => void): () => void {
  let accumulator = 0;
  let last = performance.now();
  let rafId = 0;

  const frame = (now: number): void => {
    rafId = requestAnimationFrame(frame);
    let dt = (now - last) / 1000;
    last = now;
    if (dt > MAX_FRAME_DT) dt = MAX_FRAME_DT;

    accumulator += dt;
    let steps = 0;
    while (accumulator >= FIXED_DT && steps < MAX_SUBSTEPS) {
      tick();
      accumulator -= FIXED_DT;
      steps += 1;
    }
    if (steps === MAX_SUBSTEPS) accumulator = 0; // drop the backlog

    draw();
  };

  rafId = requestAnimationFrame(frame);
  return () => cancelAnimationFrame(rafId);
}
